import { render, staticRenderFns } from "./PayrollUploadDragAndDrop.vue?vue&type=template&id=54cb4cfd&scoped=true&"
import script from "./PayrollUploadDragAndDrop.vue?vue&type=script&lang=ts&"
export * from "./PayrollUploadDragAndDrop.vue?vue&type=script&lang=ts&"
import style0 from "./PayrollUploadDragAndDrop.vue?vue&type=style&index=0&id=54cb4cfd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb4cfd",
  null
  
)

export default component.exports